import React from 'react';
import PropTypes from 'prop-types';
import { Row } from 'react-bootstrap';

const StringUtil = require('../../../../app/shared/StringUtil');
import SortableTable2 from '../table/SortableTable2';
import ActivityAnalyticsView from './ActivityAnalyticsView';

const propTypes = {
    activities: PropTypes.array,
    onActivityClick: PropTypes.func.isRequired,
    activityId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    projectId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    channelId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired
};

const defaultProps = {
    activities: [],
    activityId: null,
    projectId: null
};

class ActivityListAnalyticsView extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showLeftColumn: true
        };

        this.toggleShowLeftColumn = this.toggleShowLeftColumn.bind(this);
    }

    toggleShowLeftColumn(e) {
        this.setState({ showLeftColumn: !this.state.showLeftColumn });
    }

    render() {
        return (
            <Row className="main-content-nav">
                <div className="main-content col-12">
                    <Row>
                        <div
                            className="col-sm-12 col-md-4 col-lg-3 padding-all-md"
                            style={ this.state.showLeftColumn ? {} : { display: "none" } }
                        >
                            <h2
                                className="large-heading margin-bottom-lg"
                                role="button"
                                onClick={this.toggleShowLeftColumn}
                            >
                                <span className="fa fa-caret-down margin-right-sm" aria-hidden="true" />
                                Activities
                            </h2>
                            <SortableTable2
                                classNameTable="font-size-md"
                                rows={this.props.activities}
                                selectedRowKey={parseInt(this.props.activityId, 10)}
                                onRowClick={this.props.onActivityClick}
                                defaultSort={{ key: 'title', type: 'string', asc: true }}
                                displayColumnCallbacks={{
                                    'assignment_count': (num) => StringUtil.numberToLocaleString(num),
                                    'student_count': (num) => StringUtil.numberToLocaleString(num),
                                }}
                                columns={[
                                        {
                                            displayName: 'Title',
                                            key: 'title',
                                            type: 'string',
                                            width: '50%'
                                        },
                                        {
                                            displayName: 'Assignments',
                                            key:'assignment_count',
                                            type: 'int',
                                            width: '30%'
                                        },
                                        {
                                            displayName: 'Students',
                                            key: 'student_count',
                                            type: 'int',
                                            width: '20%'
                                        }
                                    ]}
                            />
                        </div>
                        <div className={ this.state.showLeftColumn ? "col-sm-12 col-md-8 col-lg-9 padding-all-md" : "col-12 padding-all-md" }>
                            <div>
                                {(!this.state.showLeftColumn) &&
                                    <h2
                                        className="large-heading margin-bottom-lg"
                                        role="button"
                                        onClick={this.toggleShowLeftColumn}
                                    >
                                        <span className="fa fa-caret-right margin-right-sm" aria-hidden="true" />
                                        Activities
                                    </h2>
                                }
                                {(!!this.props.activityId) ?
                                    <ActivityAnalyticsView
                                        activityId={this.props.activityId}
                                        projectId={this.props.projectId}
                                        channelId={this.props.channelId}
                                    />
                                    :
                                    <h2 className="heading-md text-centered margin-top-lg">
                                        Select an activity from the list
                                    </h2>
                                }
                            </div>
                        </div>
                    </Row>
                </div>
            </Row>
        );
    }
}

ActivityListAnalyticsView.propTypes = propTypes;
ActivityListAnalyticsView.defaultProps = defaultProps;

export default ActivityListAnalyticsView;